var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95245 2.91035C8.29113 2.86027 8.64051 2.83341 9.00035 2.83341C13.2545 2.83341 16.0461 6.58745 16.9839 8.07243C17.0974 8.25217 17.1542 8.34203 17.1859 8.48064C17.2098 8.58474 17.2098 8.74897 17.1859 8.85306C17.1541 8.99167 17.097 9.08213 16.9827 9.26305C16.7328 9.65854 16.3518 10.2143 15.8471 10.8171M4.6036 4.26261C2.80187 5.48483 1.57871 7.1829 1.01759 8.07115C0.903571 8.25164 0.846562 8.34189 0.814783 8.48048C0.790914 8.58458 0.790905 8.74878 0.814761 8.85288C0.846525 8.99148 0.903276 9.08134 1.01678 9.26106C1.95462 10.746 4.74618 14.5001 9.00035 14.5001C10.7157 14.5001 12.1932 13.8897 13.4073 13.0639M1.50035 1.16675L16.5003 16.1667M7.23258 6.89898C6.78017 7.35139 6.50035 7.97639 6.50035 8.66675C6.50035 10.0475 7.61963 11.1667 9.00035 11.1667C9.6907 11.1667 10.3157 10.8869 10.7681 10.4345",
    stroke: "#475467",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.2b75fd90abcf86f3554a6fffa25a03f6.svg";
export { ForwardRef as ReactComponent };